import { render, staticRenderFns } from "./CaseTemplateCard.vue?vue&type=template&id=5dbfa740"
import script from "./CaseTemplateCard.vue?vue&type=script&lang=js"
export * from "./CaseTemplateCard.vue?vue&type=script&lang=js"
import style0 from "./CaseTemplateCard.vue?vue&type=style&index=0&id=5dbfa740&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports